import { render } from "./calendarDayCertificationsModal.vue?vue&type=template&id=2f4385e0&scoped=true&ts=true"
import script from "./calendarDayCertificationsModal.vue?vue&type=script&lang=ts"
export * from "./calendarDayCertificationsModal.vue?vue&type=script&lang=ts"

import "./calendarDayCertificationsModal.vue?vue&type=style&index=0&id=2f4385e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4385e0"]])

export default __exports__